import React, { ReactNode } from 'react';

type RouteToOptions = {
  replace?: boolean;
};

type RouteToFunction = (url: string, options?: RouteToOptions) => void;

type LinkProviderProps = {
  children: ReactNode;
  routeTo: RouteToFunction;
};

type LinkContextValue = {
  routeTo: null | RouteToFunction;
};

const defaultContext: LinkContextValue = {
  routeTo: null,
};

const LinkContext = React.createContext(defaultContext);

export const useLink = () => React.useContext(LinkContext);

/**
 * React context that provides the `routeTo` function to `Link`
 * components to be able to do client side routing when needed
 */
export const LinkProvider = ({ children, routeTo }: LinkProviderProps) => {
  return children ? (
    <LinkContext.Provider value={{ routeTo }}>
      {React.Children.only(children)}
    </LinkContext.Provider>
  ) : null;
};
